const redirects = (t, enableNewHome) => {
  {
    const routes = [
      {
        path: '/',
        redirectPath: enableNewHome ? t('routes.home') : t('routes.sitesPage'),
      },
      {
        path: `${t('routes.emailVerify')}/:changeFlow?`,
        redirectPath: t('routes.sitesPage'),
      },
      {
        path: `${t('routes.phoneVerify')}/:changeFlow?`,
        redirectPath: enableNewHome ? t('routes.home') : t('routes.sitesPage'),
      },
      {
        path: t('routes.onboarding'),
        redirectPath: enableNewHome ? t('routes.home') : t('routes.sitesPage'),
      },
      {
        path: t('routes.persona'),
        redirectPath: enableNewHome ? t('routes.home') : t('routes.sitesPage'),
      },
      {
        path: t('routes.newSite'),
        redirectPath: enableNewHome ? t('routes.home') : t('routes.sitesPage'),
      },
      {
        path: t('routes.invoices'),
        redirectPath: `${t('routes.invoices')}${t('routes.unpaid')}`,
      },
      {
        path: t('routes.helpRedirect'),
        redirectPath: t('routes.help'),
      },
      {
        path: `${t('routes.helpRedirect')}${t('routes.supportforms')}`,
        redirectPath: `${t('routes.help')}${t('routes.supportforms')}`,
      },
      {
        path: 'non existant path -- force logic',
        redirectPath: t('routes.myData'),
      },
    ];

    routes.push();

    return routes;
  }
};

export default redirects;
